import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit']

  select ({ params: { label } }) {
    this.submitTarget.value = label
  }
}
